import config from "flow/config";
import metaCache from "flow/utils/metaCache";
import environment from "flow/configuration/environment";
import { Dictionary } from "flow/api/types";
import baseUrl from "flow/wrappers/baseUrl";

const flow3Url = new URL(baseUrl).origin + "/WE.Flow3/";

function generateFlow3Url(productId: string, payload?: Dictionary, fragment?: string): string {
    return `${flow3Url}${generateProductConfigParams(productId, payload)}${fragment}`;
}

function generateHash(workingContextId: string, viewContext: Dictionary, selectedContainerId: string) {
    const stepObject = convertToObject(workingContextId, viewContext, selectedContainerId);
    const jsonStep = JSON.stringify(stepObject);
    const encodedStep = encodeURIComponent(jsonStep);

    return encodedStep;
}

function generateHashForFunction(productId: string, payload: Dictionary, id: string, viewContext: Dictionary) {
    const url = generateUrlBasedOnStep(
        productId,
        payload,
        config.componentIds.defaultWorkingContextFlow3,
        {
            id: id,
            args: viewContext
        },
        undefined
    );
    return url;
}

function generateHashForContext(
    productId: string,
    payload: Dictionary,
    id: string,
    viewContext: Dictionary,
    selectedContainerId?: string
) {
    const url = generateUrlBasedOnStep(productId, payload, id, viewContext, selectedContainerId);
    return url;
}

function generateUrlBasedOnStep(
    productId: string,
    payload: Dictionary,
    workingContextId: string,
    viewContext: Dictionary,
    selectedContainerId: string
) {
    const runtimeContext = environment.get(environment.keys.runtimeContext) as string;

    const url = runtimeContext.toLowerCase().includes("public")
        ? metaCache.lookup("Public.Address.we_flow3_Public", "Public.Address.we_flow3_Public")
        : metaCache.lookup("Public.Address.we_flow3_Intranet", "Public.Address.we_flow3_Intranet");

    const query = generateProductConfigParams(productId, payload);
    const hash = "#" + generateHash(workingContextId, viewContext, selectedContainerId);
    return url + query + hash;
}

function isEmpty(obj: Dictionary) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}

function convertToObject(workingContextId: string, viewContext: Dictionary, selectedContainerId: string) {
    const obj: Dictionary = {
        w: workingContextId
    };

    if (viewContext && !isEmpty(viewContext)) {
        obj.vc = viewContext;
    }
    if (workingContextId !== config.componentIds.defaultWorkingContextFlow3) {
        if (selectedContainerId) {
            obj.c = selectedContainerId;
        } else if (viewContext && viewContext.selectedContainerId) {
            obj.c = viewContext.selectedContainerId;
        }
    }

    return obj;
}

function generateProductConfigParams(productId: string, payload: Dictionary): string {
    if (productId) {
        const configObj = {
            productId: productId
        };

        const searchParams = new URLSearchParams(configObj);

        if (payload) {
            searchParams.set("payload", JSON.stringify(payload));
        }

        return "?" + searchParams.toString();
    }

    return "";
}

export default {
    generateFlow3Url,
    generateHash,
    generateHashForFunction,
    generateHashForContext
};
